<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <mat-label>Select Counter</mat-label>
        <mat-select [(ngModel)]="selected_counter_id" class="main-border-class" (ngModelChange)="changeEvent()">
          <mat-option [value]="counter.id" *ngFor="let counter of counter_list">{{counter['name']}}</mat-option>
          <!-- <mat-option value="online">Online</mat-option> -->
        </mat-select>
      </div>
      <div class="col-3">
        <mat-label>Select Date</mat-label>
        <input type="date" [(ngModel)]="selected_date"  (ngModelChange)="changeEvent()" class="main-border-class" />
      </div>
      <div class="col-2">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 10%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="selected_date == null || selected_counter_id == null">Get</button>
      </div>
      <div *ngIf="!is_document_available" class="col-2">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
        </mat-progress-spinner>
      </div>
      <div class="col-2" *ngIf="document_file!== null">
        <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top:25px"><i class="material-icons">
            picture_as_pdf
          </i> Download report</button>
      </div>
    </div>
  </div>
  <iframe [src]="pdf_data" width="100%" height="800" *ngIf="document_file!== null"></iframe>

</section>
